<section #zone class="zone">
  <div
    #contentWrapper
    class="content"
    [class.transitive]="transitioned$ | async"
    [style.transform]="wrapperTransform$ | async"
    (dblclick)="reset()"
  >
    <img #image [src]="imgSrc" />
  </div>
</section>
